import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  InputHLPure,
  ButtonHLPure,
  GridSimpleReadHLPure,
  TextAreaHLPure,
  SimpleLoading,
  DialogSystemGLPure,
  GridSelectionHLPure,
  Traslates,
  FormDatePicker
} from "../../pures";
import { Grid } from "@material-ui/core";
import LabelPure from "../../pures/label/label.pure";
import "./contracting-registration-resume.view.css";
import { ContractorService, WorkflowService } from "../../../services";
import { useHistory } from "react-router-dom";

const ContractingRegistrationResumeView = (props) => {
  const { t } = useTranslation();
  const history = useHistory();

  const {
    url,
    token,
    step,
    onHandleBack,
    onHandleNext,
    personTypes,
    showLoadingRequesting,
    showCompletedRequesting,
    showErrorRequesting,
    toggleLoadingRequesting,
    toggleCompletedRequesting,
    toggleErrorRequesting,
    user,
    idContractor,
    typePersonId,
    contractWorkFlow,
    message,
    isFreelanceView,
    getFreelanceData,
    freelanceData,
    handleFinishFree,
    documentsFree
  } = props;

  const { next, back } = step;
  const [selectedDocumentGrid, setSelectedDocumentGrid] = useState({});
  const [nameOrBussinessName, setNameOrBussinessName] = useState("");
  const [typePerson, setTypePerson] = useState("");
  const [rfc, setRfc] = useState("");
  const [address, setAddress] = useState("");
  const [documentsToShow, setDocumentsToShow] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [curp, setCurp] = useState('')
  const [birthPlace, setBirthPlace] = useState('')
  const [nationality, setNationality] = useState('')
  const [date, setDate] = useState('')
  const [passport, setPassport] = useState('')
  const [city, setCity] = useState('')
  const [state, setState] = useState('')
  const [cp, setCp] = useState('')

  const workflowService = new WorkflowService(url);
  let contractorService = new ContractorService(url);

  const headerColumnOne = (props) => {
    return <span className="contractingRegistrationDocumentsView-header-cell-one">{props.title}</span>;
  };

  const cellColumnOne = (props) => {
    let subtitle = (props.dataItem.dateToShow && props.dataItem.dateToShow !== '') ? `${t("contractingRegistrationDataView.grid.registeredThe")} ${props.dataItem.dateToShow}` : props.dataItem.status
    return (
      <td className="contractingRegistrationDocumentsView-cell-one">
        <div className="contractingRegistrationDocumentsView-container-cell-one">
          <div className="contractingRegistrationDocumentsView-container-span">
            <span className="contractingRegistrationDocumentsView-span-name">
              {props.dataItem.name}
            </span>
          </div>
          <div>
            <span>
              {subtitle}
            </span>
          </div>
        </div>
      </td>
    );
  };

  const headerColumnOneFree = (props) => {
    return <span className="contractingRegistrationDocumentsView-header-cell-one-free">{props.title}</span>;
  };

  const headerColumnTwoFree = (props) => {
    return <span className="documentPanelBarExpediente-header-cell-two">{props.title}</span>;
  };

  const cellColumnOneFree = (props) => {
    return (
      <td className="contractingRegistrationDocumentsView-cell-one-free">
        <span className="">
          {props.dataItem.name}
        </span>
      </td>
    );
  };

  const cellColumnTwoFree = (props) => {
    let subtitle = (props.dataItem.dateToShow && props.dataItem.dateToShow !== '') ? `${t("contractingRegistrationDataView.grid.registeredThe")} ${props.dataItem.dateToShow}` : props.dataItem.status
    return (
      <td className="contractingRegistrationDocumentsView-cell-two-free">
        <span>
          {subtitle}
        </span>
      </td>
    )
  }

  let heightGrid = '320px'
  if (isFreelanceView) {
    if (documentsFree.length === 0) {
      heightGrid = '150px'
    } else if (documentsFree.length === 1) {
      heightGrid = '120px'
    } else if (documentsFree.length === 2) {
      heightGrid = '200px'
    } else if (documentsFree.length === 3) {
      heightGrid = '280px'
    } else {
      heightGrid = '320px'
    }
  }

  const onHandleFinish = async (e) => {
    toggleLoadingRequesting(true);
    let messageError = "Error al terminar el alta del contratante";
    let workflowContractorId = contractWorkFlow.workflow.workflowExecutionId
    try {
      let finishContractor = await contractorService.finishContractorRequest(workflowContractorId, idContractor, token)
      if (finishContractor && finishContractor.data && Number(finishContractor.statusCode) === 200) {
        toggleLoadingRequesting(false)
        toggleCompletedRequesting(true)
        setTimeout(() => {
          toggleCompletedRequesting(false)
          history.push('/');
        }, 3000)
      } else {
        toggleLoadingRequesting(false);
        toggleErrorRequesting(true, messageError);
        setTimeout(() => {
          toggleErrorRequesting(false);
        }, 3000);
      }
    } catch (error) {
      toggleLoadingRequesting(false);
      toggleErrorRequesting(true, messageError);
      setTimeout(() => {
        toggleErrorRequesting(false);
      }, 3000);
    }
  };

  //get contractor
  const getContractor = async () => {
    setIsLoading(true);
    if (personTypes.length === 0) {
      return;
    }

    try {
      let contractorService = new ContractorService(url);
      let contractor = await contractorService.getContarctorByEmailAndClientId(
        idContractor,
        token
      );

      if (contractor && contractor.contractor.contractorTypeId) {
        let copyTypePerson = [...personTypes];
        let typePersonAdd = copyTypePerson.find((type) => type.id === Number(contractor.contractor.contractorTypeId));
        let typePersoneName = (typePersonAdd) ? typePersonAdd.name : "Contratante Persona Física";
        let street =
          contractor.contractor &&
            contractor.contractor.contractorStreet !== null &&
            contractor.contractor.contractorStreet &&
            contractor.contractor.contractorStreet !== undefined
            ? contractor.contractor.contractorStreet
            : "";
        let contractorTownship =
          contractor.contractor &&
            contractor.contractor.contractorTownship !== null &&
            contractor.contractor.contractorTownship &&
            contractor.contractor.contractorTownship !== undefined
            ? contractor.contractor.contractorTownship
            : "";
        let contractorState =
          contractor.contractor &&
            contractor.contractor.contractorState !== null &&
            contractor.contractor.contractorState &&
            contractor.contractor.contractorState !== undefined
            ? contractor.contractor.contractorState
            : "";
        let streetComa = street && street !== '' ? `${street},` : street
        let contractorTownshipComa = contractorTownship && contractorTownship !== '' ? `${contractorTownship},` : contractorTownship
        let contractorStateComa = contractorState && contractorState !== '' ? `${contractorState},` : contractorState
        let addressComplete = `${streetComa} ${contractorTownshipComa} ${contractorStateComa} ${contractor.contractor.contractorCountry}`;
        setNameOrBussinessName(contractor.contractor.name);
        setTypePerson(typePersoneName);
        setRfc(contractor.contractor.rfc);
        setAddress(addressComplete);
      }
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  };

  //get documents client
  const getContractorClientDocument = async () => {
    let documents = [];
    try {
      let contractorService = new ContractorService(url)
      let contractorClientDocument = await contractorService.getContractorClientDocuments(idContractor, token)
      if (contractorClientDocument && contractorClientDocument.data && contractorClientDocument.data.data && Number(contractorClientDocument.status) === 200) {
        for (let index = 0; index < contractorClientDocument.data.data.length; index++) {
          let info = {}
          info.id = contractorClientDocument.data.data[index].id
          info.clientDocumentId = contractorClientDocument.data.data[index].clientDocumentId
          info.name = contractorClientDocument.data.data[index].clientDocument.name
          info.description = contractorClientDocument.data.data[index].clientDocument.description
          info.createdDate = contractorClientDocument.data.data[index].createdDate
          info.userId = contractorClientDocument.data.data[index].userId
          info.path = contractorClientDocument.data.data[index].path
          info.updatedDate = contractorClientDocument.data.data[index].updatedDate
          info.dateToShow = contractorClientDocument.data.data[index].documentWasLoaded === true ? contractorClientDocument.data.data[index].updatedDate : ''
          info.status = contractorClientDocument.data.data[index].documentWasLoaded === true ? t("contractingRegistrationDataView.grid.registeredThe") : t("contractingRegistrationDataView.grid.pending")
          info.documentWasLoaded = contractorClientDocument.data.data[index].documentWasLoaded
          if (contractorClientDocument.data.data[index].documentWasLoaded === true) {
            documents.push(info)
          }
        }

        setDocumentsToShow(documents);
      }
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (typePersonId && idContractor) {
      getContractorClientDocument();
      getContractor();
    }
  }, [typePersonId, idContractor]);

  useEffect(() => {
    if (!isFreelanceView) return
    setIsLoading(true);
    getFreelanceData()
  }, [isFreelanceView])

  useEffect(() => {
    if (!freelanceData) return
    setNameOrBussinessName(freelanceData.name)
    setRfc(freelanceData.rfc)
    setAddress(freelanceData.address)
    setCurp(freelanceData.curp)
    setBirthPlace(freelanceData.birthPlace)
    setNationality(freelanceData.nationality)
    setDate(freelanceData.date)
    setPassport(freelanceData.passport)
    setCity(freelanceData.city)
    setState(freelanceData.state)
    setCp(freelanceData.cp)
    setIsLoading(false);
  }, [freelanceData])

  useEffect(() => {
    if (!documentsFree || documentsFree.length === 0) return
    setDocumentsToShow(documentsFree)
  }, [documentsFree])

  return (
    <div className="contractingRegistrationResumeView-container">
      {isLoading ? (
        <SimpleLoading />
      ) : (
        <>
          {showLoadingRequesting ? (
            <DialogSystemGLPure
              showLoadingRequesting={showLoadingRequesting}
              toggleLoadingRequesting={toggleLoadingRequesting}
            />
          ) : null}
          {showErrorRequesting ? (
            <DialogSystemGLPure
              showErrorRequesting={showErrorRequesting}
              toggleErrorRequesting={toggleErrorRequesting}
              message={message}
            />
          ) : null}
          {showCompletedRequesting ? (
            <DialogSystemGLPure
              showCompletedRequesting={showCompletedRequesting}
              toggleCompletedRequesting={toggleCompletedRequesting}
            />
          ) : null}

          <Grid container lg={12} md={12} sm={12} xs={12}>
            <Grid item lg={12} md={12} sm={12} xs={12} className="contractingRegistrationResumeView-container-inputs">
              <Grid item lg={6} md={6} sm={12} xs={12} className="contractingRegistrationResumeView-container-right">
                <div className="contractingRegistrationResumeView-div-padding-bottom">
                  <LabelPure
                    title={t(
                      "contractingRegistrationResumeView.resume.register.contracting"
                    )}
                  />
                </div>
                <div className="contractingRegistrationResumeView-div-padding-bottom">
                  <InputHLPure
                    typeInput="text"
                    labelInput={t(
                      "contractingRegistrationResumeView.name.or.bussiness.name"
                    )}
                    valueInput={nameOrBussinessName || ""}
                    disabled={true}
                    // handleChangeInput={(e) => onChangeBussinessName(e)}
                    tooltipShow={false}
                    informationIcon={false}
                    inputActive={true}
                  />
                </div>
                <div className="contractingRegistrationResumeView-div-padding-bottom">
                  <InputHLPure
                    typeInput="text"
                    labelInput={t(
                      "contractingRegistrationResumeView.type.person"
                    )}
                    valueInput={typePerson || "Persona Moral"}
                    disabled={true}
                    // handleChangeInput={(e) => onChangeBussinessName(e)}
                    tooltipShow={false}
                    informationIcon={false}
                    inputActive={true}
                  />
                </div>
                <InputHLPure
                  typeInput="text"
                  labelInput={t("taxDataInvoaInvoicingView.rfc")}
                  valueInput={rfc || ""}
                  disabled={true}
                  // handleChangeInput={(e) => onChangeBussinessName(e)}
                  tooltipShow={false}
                  informationIcon={false}
                  inputActive={true}
                />
                {
                  isFreelanceView && (
                    <div className="contractingRegistrationResumeView-curp">
                      <InputHLPure
                        typeInput="text"
                        labelInput={t("registrationFreelanceDataView.curp")}
                        valueInput={curp}
                        disabled={true}
                        tooltipShow={false}
                        informationIcon={false}
                        inputActive={true}
                      />
                    </div>
                  )
                }
                {
                  isFreelanceView && (
                    <div className="contractingRegistrationResumeView-curp">
                      <InputHLPure
                        typeInput="text"
                        labelInput={t("registrationFreelanceDataView.brithplace")}
                        valueInput={birthPlace}
                        disabled={true}
                        tooltipShow={false}
                        informationIcon={false}
                        inputActive={true}
                      />
                    </div>
                  )
                }
                {
                  isFreelanceView && (
                    <div className="contractingRegistrationResumeView-curp">
                      <InputHLPure
                        typeInput="text"
                        labelInput={t("registrationFreelanceDataView.nationality")}
                        valueInput={nationality}
                        disabled={true}
                        tooltipShow={false}
                        informationIcon={false}
                        inputActive={true}
                      />
                    </div>
                  )
                }
                {
                  isFreelanceView && (
                    <div className="contractingRegistrationResumeView-curp">
                      <span className="registrationFreelanceDataView-date">{t("registrationFreelanceDataView.date")}</span>
                      <Traslates>
                        <FormDatePicker
                          id={"date"}
                          name={"date"}
                          format="dd-MM-yyyy"
                          value={date}
                          disabled
                        />
                      </Traslates>
                    </div>
                  )
                }
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12} className="contractingRegistrationResumeView-container-left">
                <TextAreaHLPure
                  labelTextArea={t('contractingRegistrationResumeView.address')}
                  valueTextData={address || ''}
                  // handleChangeInput={(e) => onChangeBussinessName(e)}
                  tooltipShow={false}
                  informationIcon={false}
                />
                {
                  isFreelanceView && (
                    <div className="contractingRegistrationResumeView-curp">
                      <InputHLPure
                        typeInput="text"
                        labelInput={t("registrationFreelanceDataView.passport")}
                        valueInput={passport}
                        disabled={true}
                        tooltipShow={false}
                        informationIcon={false}
                        inputActive={true}
                      />
                    </div>
                  )
                }
                {
                  isFreelanceView && (
                    <div className="contractingRegistrationResumeView-curp">
                      <InputHLPure
                        typeInput="text"
                        labelInput={t("registrationFreelanceDataView.city")}
                        valueInput={city}
                        disabled={true}
                        tooltipShow={false}
                        informationIcon={false}
                        inputActive={true}
                      />
                    </div>
                  )
                }
                {
                  isFreelanceView && (
                    <div className="contractingRegistrationResumeView-curp">
                      <InputHLPure
                        typeInput="text"
                        labelInput={t("registrationFreelanceDataView.state")}
                        valueInput={state}
                        disabled={true}
                        tooltipShow={false}
                        informationIcon={false}
                        inputActive={true}
                      />
                    </div>
                  )
                }
                {
                  isFreelanceView && (
                    <div className="contractingRegistrationResumeView-curp">
                      <InputHLPure
                        typeInput="text"
                        labelInput={t("registrationFreelanceDataView.cp")}
                        valueInput={cp}
                        disabled={true}
                        tooltipShow={false}
                        informationIcon={false}
                        inputActive={true}
                      />
                    </div>
                  )
                }
              </Grid>
            </Grid>
            {
              isFreelanceView ? (
                <Grid item className="contractingRegistrationDocumentsView-grid-documents-free">
                  <GridSelectionHLPure
                    styleGeneral={true}
                    styleGeneralClass={"contractingRegistrationDocumentsView-general-grid-free"}
                    pageable={false}
                    skip={0}
                    take={documentsToShow.length}
                    dataGrid={documentsToShow}
                    filter={false}
                    columnTwo={true}
                    titleRow1={t("registrationFreelanceDataView.documents.free")}
                    titleRow2={t("registrationFreelanceDataView.actions.free")}
                    headerColumnOne={headerColumnOneFree}
                    headerColumnTwo={headerColumnTwoFree}
                    cellColumnOne={cellColumnOneFree}
                    cellColumnTwo={cellColumnTwoFree}
                    styleGrid={{ height: heightGrid }}
                  />
                </Grid>
              ) : (
                <Grid
                  item
                  className="contractingRegistrationDocumentsView-gridContainer"
                >
                  <GridSelectionHLPure
                    skip={0}
                    take={5}
                    dataGrid={documentsToShow}
                    filter={true}
                    onSelectedItem={setSelectedDocumentGrid}
                    cellColumnOne={cellColumnOne}
                    headerColumnOne={headerColumnOne}
                    titleRow1={t("contractingRegistrationDocumentsView.title.cell.1")}
                    widthColumnOne={100}
                  />
                </Grid>
              )
            }
          </Grid>
          <div className="contractingRegistrationResumeView-container-btns">
            <div className="contractingRegistrationResumeView-container-btn-seconday">
              <ButtonHLPure
                nameBtn={back}
                primary={false}
                onClickBtn={(event) => onHandleBack(event)}
              />
            </div>
            <ButtonHLPure
              nameBtn={next}
              primary={true}
              onClickBtn={(isFreelanceView) ? () => handleFinishFree() : (event) => onHandleFinish(event)}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default ContractingRegistrationResumeView;
